type TeamInfo = { name: string; color: string };

const TEAMS: Record<string, TeamInfo> = {
  ATL: { name: "Hawks", color: "#EF1541" },
  BOS: { name: "Celtics", color: "#05AC3F" },
  BKN: { name: "Nets", color: "#069DE0" },
  CHA: { name: "Hornets", color: "#069DE0" },
  CHI: { name: "Bulls", color: "#EF1541" },
  CLE: { name: "Cavaliers", color: "#FCCC12" },
  DAL: { name: "Mavericks", color: "#069DE0" },
  DEN: { name: "Nuggets", color: "#FCCC12" },
  DET: { name: "Pistons", color: "#EF1541" },
  GSW: { name: "Warriors", color: "#FCCC12" },
  HOU: { name: "Rockets", color: "#FCCC12" },
  IND: { name: "Pacers", color: "#FCCC12" },
  LAC: { name: "Clippers", color: "#EF1541" },
  LAL: { name: "Lakers", color: "#FCCC12" },
  MEM: { name: "Grizzlies", color: "#069DE0" },
  MIA: { name: "Heat", color: "#FCCC12" },
  MIL: { name: "Bucks", color: "#069DE0" },
  MIN: { name: "Timberwolves", color: "#05AC3F" },
  NOP: { name: "Pelicans", color: "#FCCC12" },
  NYK: { name: "Knicks", color: "#FF7112" },
  OKC: { name: "Thunder", color: "#FCCC12" },
  ORL: { name: "Magic", color: "#069DE0" },
  PHI: { name: "76ers", color: "#EF1541" },
  PHX: { name: "Suns", color: "#FF7112" },
  POR: { name: "Trail Blazers", color: "#EF1541" },
  SAC: { name: "Kings", color: "#6E55DC" },
  SAS: { name: "Spurs", color: "#069DE0" },
  TOR: { name: "Raptors", color: "#EF1541" },
  UTA: { name: "Jazz", color: "#FCCC12" },
  WAS: { name: "Wizards", color: "#EF1541" },
};

export { TEAMS };
